import React from 'react';

import HtmlToReact from 'components/common/HtmlToReact';
import useMartyContext from 'hooks/useMartyContext';

import css from 'styles/components/productdetail/ingredients.scss';

interface OwnProps {
  ingredients?: string;
}

export const Ingredients = ({ ingredients }: OwnProps) => {
  const { testId } = useMartyContext();

  return (
    <div className={css.ingredientsSection} itemProp="ingredients" data-test-id={testId('ingredientsSection')}>
      <div className={css.description}>
        <ul className={css.listContainer}>
          <li className={css.ingredients} data-test-id={testId('ingredientsList')}>
            <HtmlToReact noContainer={true}>{ingredients}</HtmlToReact>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Ingredients;
